import DateTimePickerWrapper from "@/Components/Scheduling/Cronofy/DateTimePickerWrapper";
import { CronofyElement } from "@/Components/Scheduling/Cronofy/cronofyElement";
import DataLoadingModal from "@/Components/UI/DataLoadingModal";
import { LoadsLifeAreas } from "@/types/lifeArea";
import { LoadsMatchingAttributes } from "@/types/matchingAttribute";
import { Coach } from "@/types/page";
import { LoadsReviews } from "@/types/review";
import { coachWithCerts } from "@/utils/fullUserNames";
import {
    createSecondBiteSchedulingCallback,
    shouldDisableSelection,
} from "@/utils/secondBiteScheduling";
import { useRef, useState } from "react";
import { SchedulerData } from "../../Scheduler";

type AvailabilityModalProps = {
    show: boolean;
    setShow: (show: boolean) => void;
    coach: Coach & LoadsLifeAreas & LoadsReviews & LoadsMatchingAttributes;
    onSecondBiteSelect?: () => void;
};

export default function AvailabilityModal({
    show,
    setShow,
    coach,
    onSecondBiteSelect,
}: AvailabilityModalProps) {
    const [schedulerModalData, setSchedulerModalData] =
        useState<SchedulerData>();

    const dateTimePickerRef = useRef<CronofyElement>(null);

    return (
        <DataLoadingModal
            id="try-coach-scheduler"
            onClose={() => setShow(false)}
            show={show}
            maxWidth="3xl"
            closeable={true}
            showCloseButton={true}
            animateClose={false}
            route={route("getSchedulerData", coach.id)}
            finishedLoadingCallback={setSchedulerModalData}
            modalData={schedulerModalData}
        >
            {schedulerModalData && (
                <div className="p-8">
                    <div className="flex flex-col items-center">
                        <div className="text-center text-xl font-bold">
                            View {coachWithCerts(coach)}'s availability
                        </div>
                        <DateTimePickerWrapper
                            ref={dateTimePickerRef}
                            elementToken={
                                schedulerModalData.cronofyElementToken
                            }
                            cronofyAccounts={schedulerModalData.cronofyAccounts}
                            coachOverride={false}
                            calendarBlockingEventIds={[]}
                            coachScheduler={schedulerModalData.coachScheduler}
                            lastAppointment={
                                schedulerModalData.appointments.lastAppointment
                            }
                            hasExtraSessionsWithCost={
                                schedulerModalData.hasExtraSessionsWithCost
                            }
                            disableSelection={shouldDisableSelection()}
                            callback={createSecondBiteSchedulingCallback(
                                onSecondBiteSelect,
                            )}
                            coachId={coach.id}
                            isRescheduling={false}
                            upcomingAppointments={null}
                        />
                    </div>
                </div>
            )}
        </DataLoadingModal>
    );
}
